import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NavigationComponent} from './navigation/navigation.component';
import {ColorsComponent} from './dev/colors/colors.component';
import {FormfieldsComponent} from './dev/formfields/formfields.component';
import {EnvironmentComponent} from './dev/environment/environment.component';

import {LoaderComponent} from './shared/loader/loader.component';
import {LoaderService} from './shared/loader/loader.service';
import {AlertComponent} from './shared/alert/alert.component';
import {ToastComponent} from './shared/toast/toast.component';

import {SainputtextComponent} from './shared/formfields/sa-input-text/sa-input-text.component';
import {SainputbooleanComponent} from './shared/formfields/sa-input-boolean/sa-input-boolean.component';
import {SaInputNumberComponent} from './shared/formfields/sa-input-number/sa-input-number.component';
import {SaInputTextareaComponent} from './shared/formfields/sa-input-textarea/sa-input-textarea.component';
import {SaLabelComponent} from './shared/formfields/sa-label/sa-label.component';
import {SaSelectComponent} from './shared/formfields/sa-select/sa-select.component';
import {HomeComponent} from './home/home.component';
import {ToastService} from './shared/toast/toast.service';
import {ToastMessageComponent} from './shared/toast/toast-message/toast-message.component';
import {BasecomponenttesterComponent} from './dev/basecomponenttester/basecomponenttester.component';
import {GoogleapiComponent} from './devgps/googleapi/googleapi.component';
import {GpssimplereadComponent} from './devgps/gpssimpleread/gpssimpleread.component';
import {WhereamiComponent} from './devgps/whereami/whereami.component';
import {MapclickComponent} from './devgps/mapclick/mapclick.component';
import {DrawonmapComponent} from './devgps/drawonmap/drawonmap.component';
import {PolygonComponent} from './devgps/polygon/polygon.component';
import {FollowmeComponent} from './devgps/followme/followme.component';
import {LoginComponent} from './login/login.component';
import {HashLocationStrategy, LocationStrategy, NgOptimizedImage} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {OrganizationsComponent} from './admin/organizations/organizations.component';
import {ScenariolistComponent} from './admin/scenariolist/scenariolist.component';
import {BeaconlistComponent} from './admin/beaconlist/beaconlist.component';
import {GpslistComponent} from './admin/gpslist/gpslist.component';
import {ScenarioeditComponent} from './admin/scenarioedit/scenarioedit.component';
import {RolesComponent} from './dev/roles/roles.component';
import {UserlistComponent} from './admin/userlist/userlist.component';
import {UsereditComponent} from './admin/useredit/useredit.component';
import {BackendtesterComponent} from './dev/backendtester/backendtester.component';
import {KmltestComponent} from './dev/kmltest/kmltest.component';
import {FiletostringComponent} from './shared/filetostring/filetostring.component';
import {FilterPipe} from './pipes/filter.pipe';
import {LimitToPipe} from './pipes/limit-to.pipe';
import {ScenariolayoutComponent} from './admin/scenarioedit/scenariolayout/scenariolayout.component';
import {SimulationComponent} from './student/simulation/simulation.component';
import {TodoComponent} from './dev/todo/todo.component';
import {SensorComponent} from './admin/sensor/sensor.component';
import {ScenariohistComponent} from './admin/scenariohist/scenariohist.component';

import {BeaconscenarioComponent} from './admin/beaconscenario/beaconscenario.component';
import {SimdebugComponent} from './student/simdebug/simdebug.component';
import {ConfigtableComponent} from './dev/configtable/configtable.component';
import {BeaconlogComponent} from './admin/beaconlog/beaconlog.component';
import {ConfirmComponent} from './shared/confirm/confirm.component';
import {D2Component} from './dev/d2/d2.component';
import {ModaltestComponent} from './dev/modaltest/modaltest.component';
import {QuillModule} from 'ngx-quill';
import {RichtexttesterComponent} from './dev/richtexttester/richtexttester.component';
import {RichtextComponent} from './shared/richtext/richtext.component';
import {QRCodeModule} from 'angularx-qrcode';
import {SaInputRadioComponent} from './shared/formfields/sa-input-radio/sa-input-radio.component';
import {LogscenbeaconComponent} from './admin/logscenbeacon/logscenbeacon.component';
import {LogscengpsComponent} from './admin/logscengps/logscengps.component';
import {ScatterComponent} from './shared/graphs/scatter/scatter.component';
import {AlarmComponent} from './student/simulation/alarm/alarm.component';
import {RssitodistComponent} from './home/rssitodist/rssitodist.component';
import {ActivitiesComponent} from './admin/activities/activities.component';
import {DbsizeComponent} from './dev/dbsize/dbsize.component';
import {ResetComponent} from './login/reset/reset.component';
import {TestresetComponent} from './login/testreset/testreset.component';
import {SaInputPasswordComponent} from './shared/formfields/sa-input-password/sa-input-password.component';
import {Scenarioedit2Component} from './admin/scenarioedit/scenarioedit2/scenarioedit2.component';
import {ScenarioedittestComponent} from './admin/scenarioedit/scenarioedittest/scenarioedittest.component';
import {ScenbeacSensConsComponent} from './admin/scenbeac-sens-cons/scenbeac-sens-cons.component';
import {FirebaseComponent} from './dev/firebase/firebase.component';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {environment} from '../environments/environment';
import {provideDatabase, getDatabase} from '@angular/fire/database';
import { KeysPipe } from './pipes/keys.pipe';
import { WorldsComponent } from './firebase/worlds/worlds.component';
import { FbscenariosComponent } from './firebase/fbscenarios/fbscenarios.component';
import { AvatarsComponent } from './firebase/avatars/avatars.component';
import { FbdocumentationComponent } from './firebase/fbdocumentation/fbdocumentation.component';
import { SurveysComponent } from './firebase/surveys/surveys.component';
import { EventsComponent } from './firebase/events/events.component';
import { AlarmsettingComponent } from './admin/alarmsetting/alarmsetting.component';
import { FbscenarioeditComponent } from './firebase/fbscenarios/fbscenarioedit/fbscenarioedit.component';
import { LessonplansComponent } from './firebase/lessonplans/lessonplans.component';
import { MeasurementsComponent } from './firebase/measurements/measurements.component';
import { RenderlogComponent } from './firebase/renderlog/renderlog.component';
import { VirtexAssetsComponent } from './virtex/virtex-assets/virtex-assets.component';
import { ExercisesComponent } from './virtex/exercises/exercises.component';
import { ExerciseEditComponent } from './virtex/exercise-edit/exercise-edit.component';
import { VscenariosComponent } from './virtex/vscenarios/vscenarios.component';
import { VscenarioeditComponent } from './virtex/vscenarioedit/vscenarioedit.component';
import { TexturesComponent } from './virtex/textures/textures.component';
import { AssetlistComponent } from './virtex/assetlist/assetlist.component';
import { FbqueriesComponent } from './virtex/fbqueries/fbqueries.component';
import { PerformanceComponent } from './virtex/performance/performance.component';
import { PerformancedetailComponent } from './virtex/performancedetail/performancedetail.component';
import { EventmanagerComponent } from './virtex/eventmanager/eventmanager.component';
import { DocuvirtexComponent } from './virtex/docuvirtex/docuvirtex.component';
import { MarkdownModule } from 'ngx-markdown'
import { InteractivitiesComponent } from './virtex/vscenarioedit/interactivities/interactivities.component';
import { LessonplanComponent } from './virtex/vscenarioedit/lessonplan/lessonplan.component';
import { ModifiersComponent } from './virtex/vscenarioedit/modifiers/modifiers.component';
import { FBSchemaComponent } from './virtex/fbschema/fbschema.component';
import { JsonTreeComponent } from './shared/json-tree/json-tree.component';
import { EventclassesComponent } from './virtex/eventclasses/eventclasses.component';
import { ExerciseAnalysisComponent } from './virtex/performance/exerciseAnalysis/exercise-analysis.component';
import { InteractivityMatrixComponent } from './virtex/interactivity-matrix/interactivity-matrix.component';
import { ModifierMatrixComponent } from './virtex/modifier-matrix/modifier-matrix.component';

@NgModule({
  declarations: [
    AppComponent,

    NavigationComponent,
    ColorsComponent,
    FormfieldsComponent,
    EnvironmentComponent,
    LoaderComponent,
    AlertComponent,
    ToastComponent,
    ToastMessageComponent,

    // ------- formfields --------------------------------
    SainputtextComponent,
    SainputbooleanComponent,
    SaInputNumberComponent,
    SaInputTextareaComponent,
    SaLabelComponent,
    SaSelectComponent,
    HomeComponent,
    BasecomponenttesterComponent,
    GoogleapiComponent,
    GpssimplereadComponent,
    WhereamiComponent,
    MapclickComponent,
    DrawonmapComponent,
    PolygonComponent,
    FollowmeComponent,
    LoginComponent,
    OrganizationsComponent,
    ScenariolistComponent,
    BeaconlistComponent,
    GpslistComponent,
    ScenarioeditComponent,
    RolesComponent,
    UserlistComponent,
    UsereditComponent,
    BackendtesterComponent,
    KmltestComponent,
    FiletostringComponent,
    FilterPipe,
    LimitToPipe,
    ScenariolayoutComponent,
    SimulationComponent,
    TodoComponent,
    SensorComponent,
    ScenariohistComponent,
    BeaconscenarioComponent,
    SimdebugComponent,
    ConfigtableComponent,
    BeaconlogComponent,
    ConfirmComponent,
    D2Component,
    ModaltestComponent,
    RichtexttesterComponent,
    RichtextComponent,
    SaInputRadioComponent,
    LogscenbeaconComponent,
    LogscengpsComponent,
    ScatterComponent,
    AlarmComponent,
    RssitodistComponent,
    ActivitiesComponent,
    DbsizeComponent,
    ResetComponent,
    TestresetComponent,
    SaInputPasswordComponent,
    Scenarioedit2Component,
    ScenarioedittestComponent,
    ScenbeacSensConsComponent,
    FirebaseComponent,
    KeysPipe,
    WorldsComponent,
    FbscenariosComponent,
    AvatarsComponent,
    FbdocumentationComponent,
    SurveysComponent,
    EventsComponent,
    AlarmsettingComponent,
    FbscenarioeditComponent,
    LessonplansComponent,
    MeasurementsComponent,
    RenderlogComponent,
    VirtexAssetsComponent,
    ExercisesComponent,
    ExerciseEditComponent,
    VscenariosComponent,
    VscenarioeditComponent,
    TexturesComponent,
    AssetlistComponent,
    FbqueriesComponent,
    PerformanceComponent,
    PerformancedetailComponent,
    EventmanagerComponent,
    DocuvirtexComponent,
    InteractivitiesComponent,
    LessonplanComponent,
  ModifiersComponent,
  FBSchemaComponent,
    JsonTreeComponent,
  EventclassesComponent,
  ExerciseAnalysisComponent,
  InteractivityMatrixComponent,
  ModifierMatrixComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MarkdownModule.forRoot(),
    ReactiveFormsModule,
    QRCodeModule,
    AppRoutingModule,
    HttpClientModule,
    QuillModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideDatabase(() => getDatabase()),
    NgOptimizedImage,
  ],
  providers: [
    LoaderService,
    ToastService,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}

